module.exports = __webpack_public_path__ + "img/store-bg.e55deba6.svg";